export const ROLES = {
  OWNER: 'OWNER',
  MANAGER: 'MANAGER',
  EMPLOYEE: 'EMPLOYEE',
};

export const PRIVILEGED_ROLES = [ROLES.OWNER, ROLES.MANAGER];
